import React, { useEffect, useState } from 'react'
import { getCallTemplatesList } from '../../CommunicationModule/ActionCreator'
import { PushExotelDataforcall } from '../ActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'

export default function Add() {
    const [loader, setLoader] = useState(false)
    const [templateList, setTemplateList] = useState([])
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [obj, setObj] = useState({
        templateId: "",
        phone1: "",
        phone2: "",
        phone3: "",
        phone4: "",
        phone5: "",
        campaign: "",
    })

    useEffect(() => {
        setLoader(true)
        getCallTemplatesList("", callback => {
            setLoader(false)
            setTemplateList(callback?.data || [])
        })

    }, [])

    const handleCHange = (e, type) => {
        const { value } = e.target;
        if (type == "templateId") {
            const [call, campaign] = value?.split("-")
            console.log("val",value,call,campaign)
            setObj((prev) => ({
                ...prev,
                "templateId": call,
                "campaign": campaign,
            }));
        } else {
            setObj((prev) => ({ ...prev, [type]: value }));
        }
    };

    const handleSave = () => {

        if (obj.campaign == "97" && (obj.phone1 === "" || obj.phone2 === "")) {
            setPopup({ show: true, popupStatus: "Template & Phone 1 & Phone 2 are Required" });
            removePopup();
            return;
        }

        if (obj.campaign == "98" && (!obj.phone1 || !obj.phone2 || !obj.phone3 || !obj.phone4 || !obj.phone5)) {
            setPopup({ show: true, popupStatus: "Template & Phone 1 - 5 are Required" });
            removePopup();
            return;
        }
        if (!obj.templateId || obj.templateId === "" || obj.phone1 === "") {
            setPopup({ show: true, popupStatus: "Template & Phone 1 is Required" });
            removePopup();
            return;
        }

        const newobj = {
            phone1: obj?.phone1,
            phone2: obj?.phone2,
            phone3: obj?.phone3,
            phone4: obj?.phone4,
            phone5: obj?.phone5,
        }
        setLoader(true)

        PushExotelDataforcall(obj.templateId, newobj, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback == "success") {
                setPopup({ show: true, popupStatus: "Data Pushed Successfully" })
                setObj({
                    templateId: "",
                    phone1: "",
                    phone2: "",
                    phone3: "",
                    phone4: "",
                    phone5: "",
                    campaign: "",
                })
            } else {
                setPopup({ show: true, popupStatus: "Error Pushing Data" })
            }
            removePopup()
        })

    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: '' })
    }
    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }
    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''
            }
            <div className='container-fluid' style={{ marginTop: '30px' }}>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="shadow" style={{ boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px", padding: "15px", borderRadius: "6px" }}>
                            <div className="row">
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Templates</label>
                                    <select className='form-control' value={`${obj.templateId}-${obj?.campaign}`} onChange={(e) => handleCHange(e, "templateId")}>
                                        <option value="">Select Option</option>
                                        {
                                            templateList?.length > 0 ? templateList?.map((v, id) => {
                                                return (
                                                    <option value={`${v?.callId}-${v?.campaignId}`}>{v?.templateName}</option>
                                                )
                                            })
                                                : ''}
                                    </select>
                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Phone Number 1</label>
                                    <input className='form-control' value={obj.phone1} type='number' onChange={(e) => handleCHange(e, "phone1")} />

                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Phone Number 2</label>
                                    <input className='form-control' value={obj.phone2} type='number' onChange={(e) => handleCHange(e, "phone2")} />

                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Phone Number 3</label>
                                    <input className='form-control' value={obj.phone3} type='number' onChange={(e) => handleCHange(e, "phone3")} />

                                </div>

                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Phone Number 4</label>
                                    <input className='form-control' value={obj.phone4} type='number' onChange={(e) => handleCHange(e, "phone4")} />

                                </div>
                                <div className="col-sm-3 col-xs-12">
                                    <label htmlFor="">Phone Number 5</label>
                                    <input className='form-control' value={obj.phone5} type='number' onChange={(e) => handleCHange(e, "phone5")} />

                                </div>
                            </div>

                            <div className='text-center' style={{ marginTop: '30px' }}>
                                <button className='btn btn-primary' onClick={() => handleSave()} >Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
